import { createAuthClient } from "better-auth/react";
import { twoFactorClient } from "better-auth/client/plugins";
import { adminClient } from "better-auth/client/plugins";
import { usernameClient } from "better-auth/client/plugins";
import { BACKEND_URL } from "@/config/env";
import { toast } from "sonner";
import { toUserMessage } from "@/lib/toast-message";

export const authClient = createAuthClient({
  baseURL: BACKEND_URL,
  plugins: [twoFactorClient(), adminClient(), usernameClient()],
  fetchOptions: {
    credentials: "include", // send cookies with same-origin requests via proxy
    onError: (ctx) => {
      const status = (ctx as any)?.error?.status;
      if (status === 403) return; // handled inline on sign-in for better ux
      const raw = (ctx as any)?.error?.message ?? (ctx as any)?.error ?? ctx;
      toast.error(toUserMessage(raw));
    },
  },
});

export const { useSession, signIn, signUp, signOut } = authClient;

// wrap signOut to clear embedded session cache global so next load refetches
export async function embeddedAwareSignOut() {
  try {
    await signOut();
  } finally {
    if (typeof window !== "undefined") {
      try {
        (window as any).__SESSION__ = null;
      } catch {}
    }
  }
}

export type Session = typeof authClient.$Infer.Session;
export type User = Session["user"];
